module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "about-team"
  }, [_c('div', {
    staticClass: "about-team__header"
  }, [_c('div', {
    staticClass: "about-team__header-col about-team__header-left"
  }, [_vm._v(_vm._s(_vm.content.team.text))]), _c('div', {
    staticClass: "about-team__header-col about-team__header-right"
  }, [_vm._v(_vm._s(_vm.content.team.title))])]), _c('div', {
    staticClass: "about-team__header--mobile"
  }, [_c('div', {
    staticClass: "about-team__header-title"
  }, [_vm._v(_vm._s(_vm.content.team.title) + "    ")]), _c('div', {
    staticClass: "about-team__header-text"
  }, [_vm._v(_vm._s(_vm.content.team.text))])]), (_vm.content) ? _c('div', {
    staticClass: "about-team-tab"
  }, [_c('div', {
    staticClass: "about-team-tab__nav"
  }, _vm._l((_vm.content.team.tabs), function(tab, i) {
    return _c('div', {
      staticClass: "about-team-tab__title",
      attrs: {
        "id": "team-tab-" + i
      },
      on: {
        "click": function($event) {
          return _vm.showTeamTabFunc(i)
        }
      }
    }, [_vm._v(_vm._s(tab.title))])
  }), 0)]) : _vm._e(), _c('TeamTabcontent', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showTeamTab),
      expression: "showTeamTab"
    }],
    attrs: {
      "content": _vm.content.team
    },
    on: {
      "close": function($event) {
        _vm.showTeamTab = false
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-02cc70be","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/custom/custom-about-team/custom-about-team.pug
// module id = 608
// module chunks = 1